import React from "react";
import { Route, Switch } from "react-router-dom";

import Jury from "../activity/jury";
import Notice from "../activity/notice/notice";
import ActivityDetail from "../activity/detail";
import Enterprise from "../activity/enter/enterprise";
import College from "../activity/enter/college";

const ActivityRouter = () => {
  return (
    <Switch>
      {/*<Route exact path="/" component={Home} />*/}
      <Route exact path="/enter/" component={College} />
      <Route exact path="/enter/enterprise" component={Enterprise} />
      <Route exact path="/enter/college" component={College} />
    </Switch>
  );
};

export default ActivityRouter;
